import React from 'react';
import { StoreType } from '../types';

interface StoreBadgeProps {
  store: StoreType | 'appstore' | 'googleplay';
  size?: 'sm' | 'md';
}

export const StoreBadge: React.FC<StoreBadgeProps> = ({ store, size = 'sm' }) => {
  if (store === 'appstore') {
    return (
      <span
        className={`inline-flex items-center gap-1.5 font-medium rounded-md border border-slate-200/80 bg-slate-50 text-slate-800 ${
          size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
        }`}
      >
        <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24">
          <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.34-.07 2.27.74 3.05.8 1.16-.24 2.27-.93 3.51-.84 1.48.12 2.6.7 3.34 1.76-3.05 1.83-2.33 5.85.47 6.98-.56 1.48-1.29 2.95-2.37 4.28ZM12.03 7.25C11.88 5.05 13.67 3.24 15.72 3c.29 2.54-2.3 4.43-3.69 4.25Z" />
        </svg>
        App Store
      </span>
    );
  }

  if (store === 'googleplay') {
    return (
      <span
        className={`inline-flex items-center gap-1.5 font-medium rounded-md border border-emerald-200/80 bg-emerald-50 text-emerald-800 ${
          size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
        }`}
      >
        <svg className="w-3 h-3 fill-emerald-700" viewBox="0 0 24 24">
          <path d="M3.609 1.814L13.792 12 3.61 22.186a2.227 2.227 0 0 1-.61-1.611V3.425c0-.624.23-1.18.609-1.611zm11.597 11.597L6.822 21.795l9.907-5.717-1.523-2.667zm0-2.822l1.523-2.667-9.907-5.717 8.384 8.384zm1.414 1.411l3.655-2.109a1.503 1.503 0 0 0 0-2.6L16.62 9.281l-1.414 1.414 1.414 1.414z" />
        </svg>
        Google Play
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center gap-1 font-medium rounded-md border border-blue-200 bg-blue-50 text-blue-800 ${
        size === 'sm' ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs'
      }`}
    >
      All Stores
    </span>
  );
};
